// import {sendUILogToBackend} from '@/services/loggingService';

import {doBuildLogger} from '../../libs/logHelper';
import {setErrorBoundary} from '../actions/appStateAction';

// eslint-disable-next-line import/prefer-default-export
export const buildLogger = (store, browserLogLevel = 1, level = 1, maxStackSize = 10, key = 'ui_log') => {
  const {dispatch, getState} = store;
  doBuildLogger(
    {
      browserLogLevel,
      level,
      maxStackSize,
      key,
      persistentLog: true,
    },
    () => {
      // sendUILogToBackend();
    },
  );

  window.onerror = (msg, url, line, col, error) => {
    const {appState} = {...getState()};

    const {isHandled} = appState.errorBoundary;
    // Note that col & error are new to the HTML 5 spec and may not be
    // supported in every browser.  It worked for me in Chrome.
    let extra = !col ? '' : `\ncolumn: ${col}`;
    extra += !error ? '' : `\nerror: ${error}`;
    const err = `'${msg}' from ${url}: ${line}${extra}`;
    // You can view the information in an alert to see things working like this:
    console.error(`Caught[via window.onerror]: ${err}`);

    // TO-DO: Report this error via ajax so you can keep track of what pages have JS issues.
    if (!isHandled) {
      dispatch(
        setErrorBoundary(true, {
          message: msg,
          stack: error.stack,
          componentStack: error,
        }),
      );
    }

    const suppressErrorAlert = false;
    // If you return true, then error alerts (like in older versions of Internet Explorer) will be suppressed.
    // return false; // same as preventDefault
    return suppressErrorAlert;
  };
};
